<div class="flex flex-col gap-4" *transloco="let t">
  <div class="flex gap-2">
    @if (filters()?.length) {
      <app-compact-filter [filters]="filters()!" (filterChange)="applyFilter($event)" />
    }
  </div>
  <div class="relative">
    @if (globalChartMetrics()) {
      <app-metric-selector
        [data]="totalData()"
        [previousPeriodData]="previousTotalData()"
        (selectedMetricsChange)="selectMetrics($event)"
        [availableMetrics]="globalChartMetrics()"
        [localStorageKey]="localStorageKey"
        [dataLoading]="globalDataLoading()"
      />
    }
    @if (!isGlobalChartHidden()) {
      <app-chart-layout
        closable
        (closeClicked)="toggleGlobalChartDisplay(true)"
        withDateAggregation
        (aggregationChange)="selectAggregation($event)"
        withEventAnnotation
        [disableEventAnnotation]="disableEventAnnotation()"
        [allEventAnnotationTypes]="allEventAnnotationTypes"
        [allStrategies]="allStrategies() ?? []"
        [dataLoading]="globalDataLoading()"
        (displayEventAnnotationChange)="toggleEventAnnotationDisplay($event)"
      >
        <IChart [data]="globalData()?.data ?? []" [config]="chartDatasetConfig()" />
      </app-chart-layout>
    } @else {
      <div class="flex justify-end">
        <button
          iButton
          variant="secondary"
          [iTooltip]="t('agency-board.show_global_chart')"
          (click)="toggleGlobalChartDisplay(false)"
        >
          <IIcon name="chartLine" />
          {{ t("agency-board.show_global_chart") }}
        </button>
      </div>
    }
  </div>
  <app-product-analysis-grid
    [gridData]="gridData()"
    [loading]="gridDataLoading()"
    [selectedMetrics]="selectedMetrics()"
    [selectedAdTypes]="selectedAdTypes()"
  ></app-product-analysis-grid>
</div>
